import * as React from 'react';
import {
  Avatar,
  Card,
  CardContent,
  ClickAwayListener,
  Divider,
  Fade,
  Grid,
  makeStyles,
  Paper,
  Popper
} from "@material-ui/core";


import PersonIcon from '@mui/icons-material/Person';

const useStyles = makeStyles(theme => ({
  
  headerAvtar: {
    cursor: "pointer",
    ...theme.typography.mediumAvatar,
    margin: "8px 0 8px 8px !important",
    color: theme.palette.purple.dark,
    
    "&:hover": {
      background: theme.palette.purple.main,
      color: theme.palette.purple.light
    }
  },
  
  cardContent: {
    padding: "16px !important"
  },
  card: {
    backgroundColor: theme.palette.primary.light,
    marginBottom: "16px",
    marginTop: "16px"
  }, 
  flex: {
    display: "flex"
  },
  name: {
    marginLeft: "2px",
    fontWeight: 400
  }
}));
const ProfileSection = ({ user }: any) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);
  
  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };
  const handleClose = (event: MouseEvent | TouchEvent) => {
    if (anchorRef?.current?.contains(event.target as HTMLElement)) {
      return;
    }
    setOpen(false);
  };
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current && !open) {
      anchorRef.current?.focus();
    }
    prevOpen.current = open;
  }, [open]);

  let role: any = [];
  user?.idTokenClaims?.roles?.map((item: any) => {
    role.push(item);
  });
  role = role.join(",");
  role = role === "" ? localStorage.getItem("userRole") : role

  return (
    <React.Fragment>
        <span><b>{user?.name}</b></span>
      <Avatar 
          className={classes.headerAvtar}
          ref={anchorRef}
          aria-controls={open ? "menu-list-grow" : undefined}
          aria-haspopup="true"
          color="inherit"> <PersonIcon onClick={handleToggle}></PersonIcon> 
      </Avatar>
          
      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, 14]
              }
            }
          ]
        }}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps}>
             <Paper sx={{ minWidth : 288}}>
              <ClickAwayListener onClickAway={handleClose}>
                <Card elevation={16}>
                  <CardContent className={classes.cardContent}>
                    <Grid container direction="column" spacing={0}>
                      <Grid item className={classes.flex}>                    
                      <span><b>{user?.name}</b></span>
                      </Grid>
                      <Grid item>
                      <span><b>{}</b></span>
                      </Grid>
                    </Grid>
                      <Divider />
                      <Card className={classes.card}>
                        <CardContent>
                          <Grid container spacing={3} direction="column">
                            <Grid item>
                              <Grid
                                item
                                container
                                alignItems="center"
                                justifyContent="space-between"
                              >
                                <Grid item>
                                  <span><b>Email :</b></span> <span>{user?.username}</span>
                                </Grid>
                                
                              </Grid>
                            </Grid>
                            <Grid item>
                              <Grid
                                item
                                container
                                alignItems="center"
                                justifyContent="space-between"
                              >
                                <Grid item>
                                <span><b>Role : </b></span> {role}<span></span>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>                 
                  </CardContent>
                </Card>
              </ClickAwayListener>
            </Paper>
          </Fade>
        )}
      </Popper>
    </React.Fragment>
  );
};
export default ProfileSection;
